module.exports = __webpack_public_path__ + "media/images/icons/material/bitbucket-dde66678071f062e5c1ddbc8fd0e42c7.svg";